// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationBiomethane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.717 21.808c.914-.554 1.474-1.522 1.474-2.52 0-.111-.06-.474-.335-1.138-.255-.618-.625-1.333-1.063-2.087a43.042 43.042 0 0 0-1.819-2.83 42.96 42.96 0 0 0-1.818 2.83c-.439.754-.809 1.469-1.064 2.087-.274.664-.334 1.027-.334 1.139 0 .997.56 1.966 1.474 2.52-3.424-.767-5.977-3.743-5.977-7.298 0-3.034 4.151-8.346 6.365-10.964a1.767 1.767 0 0 1 1.351-.643c.497 0 .994.214 1.357.643 2.214 2.618 6.365 7.93 6.365 10.964 0 2.254-1.027 4.276-2.65 5.649a7.783 7.783 0 0 1-3.326 1.648zm3.536-9.094c-.365-.831-.892-1.762-1.516-2.728-1.21-1.874-2.686-3.726-3.763-5.005C10.897 6.26 9.42 8.112 8.21 9.986c-.625.966-1.152 1.897-1.516 2.728-.38.865-.51 1.459-.51 1.797 0 1.133.374 2.216 1.028 3.116.854-2.236 2.921-5.217 4.03-6.734a.892.892 0 0 1 1.463 0c1.108 1.517 3.175 4.498 4.03 6.734a5.305 5.305 0 0 0 1.027-3.116c0-.338-.13-.932-.51-1.797z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationBiomethane;
